<img id="trademark" [src]="VoltaCommon.OISOFT_LOGO">